export enum Experiment {
  UseLocalizationService = 'specs.myAccount.UseLocalizationService',
  UseNewPrivacyModalContent = 'specs.myAccount.UseNewPrivacyModalContent',
  ShowBlockedMembersModalRedesign = 'specs.myAccount.showBlockedMembersModalRedesign',
}
